
<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>
<div class="k-overlay" *ngIf="editWinOpen"></div>

<div class="container" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'sliders']"></fa-icon> Manage Disciplines</h3>
      </div>

      <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true"
                  [groupable]="true" [resizable]="true" [filter]="filter" filterable="menu" (filterChange)="filterChange($event)"
                  (sortChange)="sortChange($event)" style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize"
                  [pageable]="true">

        <ng-template kendoGridToolbarTemplate position="top">
          <button [hidden]="!canCreate" (click)="onAdd()" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> Add Discipline </button>
        </ng-template>

        <kendo-grid-column title="Edit" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button [hidden]="!canUpdate" (click)="onEditClick(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="No. of Subscales" [width]="90">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button [hidden]="!canUpdate" (click)="onSubscaleClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid" >
              {{dataItem.no_subscales}}
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="discipline_name" title="Discipline Name" [width]="200">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                               [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>


        <kendo-grid-column title="Activate / Deactivate" field="active" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active" (click)="setActive(dataItem)" [disabled]="!canUpdate" />
          </ng-template>
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                               [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>


        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>

    </div>
  </div>

</div>

<div kendoDialogContainer></div>

<div kendoWindowContainer></div>
